import { SQLiteDBConnection } from '@capacitor-community/sqlite';
import { inject, Injectable } from '@angular/core';
import { SQLiteService } from './sqlite.service';
import { DbnameVersionService } from './dbname-version.service';
import { isPlatform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class BaseDatabaseService {
  protected sqliteService: SQLiteService = inject(SQLiteService);
  protected dbVerService: DbnameVersionService = inject(DbnameVersionService);
  public databaseName = '';
  protected loadToVersion = 1;
  protected exec?: () => Promise<void>;
  public mDb!: SQLiteDBConnection;

  protected async querySafe(query: string, values?: any[]) {
    if (!this.mDb || !(await this.checkConnectionIsValid())) {
      console.warn('🔌 Lost DB connection, trying to reconnect...');
      await this.reconnectDatabase();
    }
    return this.mDb.query(query, values);
  }

  protected async checkConnectionIsValid(): Promise<boolean> {
    try {
      const isConn = await this.sqliteService.sqliteConnection.isConnection(
        this.databaseName,
        false
      );

      return isConn?.result === true;
    } catch {
      return false;
    }
  }

  protected async reconnectDatabase() {
    try {
      this.mDb = await this.sqliteService.openDatabase(
        this.databaseName,
        false,
        'no-encryption',
        this.loadToVersion,
        false
      );
      this.dbVerService.set(this.databaseName, this.loadToVersion);
      console.info('✅ Reconnected to DB');
    } catch (e) {
      console.error('❌ Failed to reconnect DB:', e);
      throw e;
    }
  }

  async initializeDatabase(
    dbName: string,
    version: number,
    mDb: SQLiteDBConnection
  ) {
    this.databaseName = dbName;
    this.loadToVersion = version;

    if (this.databaseName) {
      this.mDb = mDb;

      this.dbVerService.set(this.databaseName, this.loadToVersion);
      if (this.exec) {
        await this.exec();
      }

      if (!isPlatform('hybrid')) {
        //if (this.sqliteService.platform === 'web') {
        await this.sqliteService.sqliteConnection.saveToStore(
          this.databaseName
        );
      }
    }
  }
}
